import type { DateTime } from 'luxon';

export interface When {
    start?: DateTime;
    finish?: DateTime;
    duration?: number;
}

export function createWhen(start: DateTime, duration: number): When {
    return {
        start,
        duration,
        finish: start.plus({ seconds: duration })
    };
}

export function updateFinish(when: When): When {
    when.finish = when.start.plus({ seconds: when.duration });
    return when;
}
